import axios from 'axios';

//const accessToken = 'EAAWW6J3CFlYBO2lSKRv3A8iHVe3rqe5DTtwwNRWP7lo8UnTZCcMUHiHNqSLxKVL2AIJ1xWQ31OxlpR0J9AvSgEhEHyOVRJniQ6dXBqase9omIcB2UY5nnjZBcffUZCDHsZBqUkSvWNoOsvApeQjENgMtgsv9QRwhcKE2tkiWvZAUEEwtlpQK18ZBa2mE2V4xbhFXEH3xAjiGNbzO0AV7PNbYjZA6bkkoyESXGRR65siNhGTbUCvgtvfPnlZBR31BMvZCzkEzZBFqZCX'; // Replace with your actual access token

const fetchFacebookMetrics = async (accessToken) => {
  try {
    console.log("fetchFBMetrics: ");
    // Fetch likes
    const likesResponse = await axios.get(`https://graph.facebook.com/me/likes?access_token=${accessToken}`);
    const likes = likesResponse.data.data;

    // Fetch posts from /me/posts
    const postsResponse = await axios.get(`https://graph.facebook.com/me/posts?access_token=${accessToken}`);
    const posts = postsResponse.data.data;

    // Fetch posts, gender, user_age_range, email, and public profile using the fields= parameter
    const fieldsResponse = await axios.get(`https://graph.facebook.com/v20.0/me?fields=posts,gender,age_range,email,name&access_token=${accessToken}`);
    const fieldsPosts = fieldsResponse.data.posts?.data || [];
    const gender = fieldsResponse.data.gender || 'Unknown';
    const ageRange = fieldsResponse.data.age_range || 'Unknown';
    const email = fieldsResponse.data.email || 'Unknown';
    const name = fieldsResponse.data.name || 'Unknown';

    return { 
      likes, 
      posts, 
      fieldsPosts, 
      gender, 
      ageRange, 
      email, 
      name 
    };
  } catch (error) {
    console.error('Error fetching Facebook metrics:', error);
    return { 
      likes: [], 
      posts: [], 
      fieldsPosts: [], 
      gender: 'Unknown', 
      ageRange: 'Unknown', 
      email: 'Unknown', 
      name: 'Unknown' 
    };
  }
};

export default fetchFacebookMetrics;
